import { Switch, Route } from 'react-router-dom';

import List from './List';

export default () => {
  const BASE_URL = '/admin/room/details/:room/talk';

  return (
    <Switch>
      <Route
        path={[`${BASE_URL}`, `${BASE_URL}/new`, `${BASE_URL}/:talk`]}
        component={List}
        exact
      />
    </Switch>
  );
};
